<template>
    <ul class="pagination plain-links w-full p-0">
        <li v-for="(pageNumber, index) in paginationNumbers" :class="{active: current_page === pageNumber}" :key="index">
            <a href="#" @click="paginationClick(pageNumber)"  :class="{last: (pageNumber == totalPages && Math.abs(pageNumber - current_page) > 3), first:(pageNumber == 1 && Math.abs(pageNumber - current_page) > 3)}">{{ pageNumber }}</a>
        </li>
    </ul>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
    name: "pagination",
    data() {
        return {
            parent: this.$parent.$options.name,
            paginationNumbers: []
        };
    },
    computed: {
        ...mapState(["totalItemsFound", "per_page", "current_page"]),
        totalPages: function() {
            return Math.ceil(this.totalItemsFound / this.per_page);
        }
    },
    watch: {
        totalItemsFound() {
            this.getPaginationNumbers();
        }
    },
    methods: {
        ...mapMutations(["setCurrentPage"]),
        ...mapActions(["getMembers"]),
        getData() {
            if (this.parent == "member-list") {
                this.getMembers().then(() => {
                    this.getPaginationNumbers();
                });
            }
        },
        paginationClick: function(pageNumber) {
            this.setCurrentPage(pageNumber);
            this.getData();
        },
        getPaginationNumbers: function() {
            this.paginationNumbers = [];

            for (
                var pageNumber = 1;
                pageNumber <= this.totalPages;
                pageNumber++
            ) {
                if (
                    Math.abs(pageNumber - this.current_page) < 3 ||
                    pageNumber == this.totalPages ||
                    pageNumber == 1
                ) {
                    this.paginationNumbers.push(pageNumber);
                }
            }
        }
    },
    created() {
        this.getData();
    }
};
</script>



// WEBPACK FOOTER //
// src/js/vue-components/pagination.vue